var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('vue-final-modal',{attrs:{"value":_vm.visible,"name":"ai-mypr-dialog","classes":['ai-mypr-dialog__container'],"content-class":[
    'ai-mypr-dialog__shell',
    'v--modal-box',
    'v--modal',
    'ai-mypr-modal',
    'ai-mypr-modal-sheet'
  ],"click-to-close":true,"esc-to-close":true,"lock-scroll":true,"attach":"body"},on:{"input":_setup.onInput,"before-close":_setup.onBeforeClose}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }